"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(func) {
  var next = function next() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length >= func.length ? func.apply(void 0, args) : function () {
      for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextArgs[_key2] = arguments[_key2];
      }

      return next.apply(void 0, args.concat(nextArgs));
    };
  };

  return next;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9jdXJyeS50cyJdLCJuYW1lcyI6WyJmdW5jIiwibmV4dCIsImFyZ3MiLCJsZW5ndGgiLCJuZXh0QXJncyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUFlLGtCQUFBQSxJQUFJLEVBQUk7QUFDckIsTUFBTUMsSUFBSSxHQUFHLFNBQVBBLElBQU87QUFBQSxzQ0FBSUMsSUFBSjtBQUFJQSxNQUFBQSxJQUFKO0FBQUE7O0FBQUEsV0FDWEEsSUFBSSxDQUFDQyxNQUFMLElBQWVILElBQUksQ0FBQ0csTUFBcEIsR0FDRUgsSUFBSSxNQUFKLFNBQVFFLElBQVIsQ0FERixHQUVFO0FBQUEseUNBQUlFLFFBQUo7QUFBSUEsUUFBQUEsUUFBSjtBQUFBOztBQUFBLGFBQWlCSCxJQUFJLE1BQUosU0FBUUMsSUFBUixRQUFpQkUsUUFBakIsRUFBakI7QUFBQSxLQUhTO0FBQUEsR0FBYjs7QUFJQSxTQUFPSCxJQUFQO0FBQ0QsQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmMgPT4ge1xuICBjb25zdCBuZXh0ID0gKC4uLmFyZ3MpID0+XG4gICAgYXJncy5sZW5ndGggPj0gZnVuYy5sZW5ndGggP1xuICAgICAgZnVuYyguLi5hcmdzKSA6XG4gICAgICAoLi4ubmV4dEFyZ3MpID0+IG5leHQoLi4uYXJncywgLi4ubmV4dEFyZ3MpO1xuICByZXR1cm4gbmV4dDtcbn1cbiJdfQ==